var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('project-sidebar',{staticClass:"bg-dark float-left vh-100 overflow-y",style:(`width: ${_vm.WIDTH_USER_SIDEBAR}px;`)}),_c('div',{style:(`margin-left: ${_vm.WIDTH_USER_SIDEBAR}px;`)},[_c('router-view',{staticClass:"inner-wrapper m-auto"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }